import { storageKeys } from '@waitroom/models';

export const syncedStorageKeys: (keyof typeof storageKeys)[] = [
  storageKeys.AUTH_TOKENS,
];
